export enum UBCMessageName {
  ScanToBasket = 'ScanToBasket',
  ShopTheCommercialList = 'ShopTheCommercialList',
  UpdateBasket = 'UpdateBasket',
  UpdateBasketSuccess = 'UpdateBasketSuccess',
  UpdateBasketError = 'UpdateBasketError',
}

export interface UBCMessage<T extends UBCMessageName, P = undefined> {
  messageName: T;
  payload: P;
}
